/**
 * GraphQL-адреса (в Nuxt 2 читаются и при сборке, и при `nuxt start`, т.е. из env контейнера):
 * - API_USED_ENDPOINT — для браузера, по умолчанию /graphql (прокси server-middleware/gql.js → API_USED_SERVER_ENDPOINT)
 * - API_USED_SERVER_ENDPOINT — для SSR и прокси; на проде внутренний http://api-used/graphql
 * - API_USED_URL_ENDPOINT — для server prepare (запросы во время сборки), полный https-адрес,
 *   например https://api.ri-advance.ru/graphql; читается из process.env там, где нужен
 */
const DEFAULT_API_SERVER_ENDPOINT = 'https://api.ri-advance.ru/graphql'

function getApiServerEndpoint() {
  return process.env.API_USED_SERVER_ENDPOINT || DEFAULT_API_SERVER_ENDPOINT
}

module.exports = {
  apiEndpoint: process.env.API_USED_ENDPOINT || '/graphql',
  apiServerEndpoint: getApiServerEndpoint(),
  getApiServerEndpoint,
}
